<script lang="ts">
  import { createEventDispatcher, getContext, onMount, tick } from 'svelte';
  import CalendarAdaptForecastModal from './CalendarAdaptForecastModal.svelte';
  import AdaptForecastHost from './AdaptForecastHost.svelte';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // The Adapt Forecast dialog, for any page: <AdaptForecastDialog bind:this={dialog} /> and dialog.openModal().
  // On a page that has the My Fitness stores (Today, Planner) it uses them. Anywhere else (the plan report) it loads
  // the plan, calendar settings and training medians the first time it is opened. 'saved' is sent when an adapted
  // forecast was saved on a page that loaded its own; 'error' carries the message when it could not be loaded.
  export let today: Date = new Date();
  export let forecastData: any[] | null = null;
  // For a page without the stores that wants to know whether Adapt Forecast is lit: load what it needs at once and send 'lit'.
  export let watch = false;

  const dispatch = createEventDispatcher();
  const hasStores = !!getContext('myFitness');
  let modal: any;
  let host: any;
  let loaded: any = null;
  let busy = false;

  async function load() {
    if (loaded) return;
    const res = await fetch('/plan-report/adapt-context', { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('The Adapt Forecast dialog could not be loaded.');
    loaded = await res.json();
    await tick();
  }
  onMount(() => {
    if (watch && !hasStores) load().catch(() => {});
  });

  export async function openModal() {
    if (busy) return;
    busy = true;
    try {
      if (!hasStores) await load();
      (hasStores ? modal : host).openModal();
    } catch (e) {
      dispatch('error', e instanceof Error ? e.message : 'The Adapt Forecast dialog could not be loaded.');
    } finally {
      busy = false;
    }
  }
</script>

{#if hasStores}
  <CalendarAdaptForecastModal bind:this={modal} {forecastData} {today} />
{:else if loaded}
  <AdaptForecastHost bind:this={host} data={loaded} {today} on:saved on:lit />
{/if}
